import { IconButton, Stack, TextField, Typography, Rating as StarRating } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
// import { Rating as Rate } from 'types/enums/Rating';

type DcumentRatingCommentStepProps = {
  disableRating: boolean;
  rating: Rate | null;
  comment: string;
  setRate: (rate: string) => void;
  setComment: (comment: string) => void;
};

const DocumentRatingCommentStep = ({
  disableRating,
  rating,
  comment,
  setRate,
  setComment,
}: DcumentRatingCommentStepProps) => {
  const { t } = useTranslation();
  // const rateList = [Rate.A, Rate.B, Rate.C, Rate.D];
  const [value, setValue] = React.useState<number | null>(0);

  const starLabels: { [index: string]: string } = {
    5: '5',
    4: '4',
    3: '3',
    2: '2',
    1: '1',
    0: '0',
  };

  function getStarLabelText(value: number) {
    return `${value} Star${value !== 1 ? 's' : ''}, ${starLabels[value]}`;
  }

  return (
    <Stack>
      {!disableRating && (
        <>
          <Typography fontWeight={500}>{t("Report client's service performance assessment")}</Typography>
          <Stack direction="row" spacing={2} sx={{ paddingBottom: 3 }}>
            <StarRating
              name="hover-feedback"
              value={value}
              precision={1}
              size="large"
              getLabelText={getStarLabelText}
              onChange={(event, newValue) => {
                setRate(newValue);
                setValue(newValue);
              }}
              sx={{
                fontSize: '2.5rem', // Adjust this value to your liking (e.g., 4rem, 60px)
                '& .MuiRating-icon': {
                  // Optional: adds a bit more spacing between larger stars
                  marginRight: '5px',
                },
              }}
            />
          </Stack>
        </>
      )}
      <Typography fontWeight={500}>{t("Report client's service performance comment")}</Typography>
      <TextField
        name="comment"
        id="comment"
        rows={11}
        className="active-blue no-border deliverables-input "
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder={t('Your text here')}
        multiline
        fullWidth
      />
      <Typography sx={{ color: '#b2bcd5' }}>{`${t('Number of characters')}: ${comment.length}/700`}</Typography>
    </Stack>
  );
};

export default DocumentRatingCommentStep;
